/** Slug for confirmation PDF filenames: lowercase, hyphenated, ASCII-safe. */
export function slugRecipientName(firstName?: string | null, lastName?: string | null): string {
  const slug = [firstName, lastName]
    .filter((part): part is string => !!part && !!part.trim())
    .map((part) =>
      part
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, ''),
    )
    .filter(Boolean)
    .join('-');
  return slug || 'recipient';
}

/** ddMMyyyy for confirmation letter filenames. */
export function formatConfirmationDate(date: Date = new Date()): string {
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = String(date.getFullYear());
  return `${day}${month}${year}`;
}

/**
 * AIRWALLEX_<TRANSFER_ID>_<PAYOUT_ID>_<ddmmyyyy>_<recipient-name>.pdf
 */
export function buildAirwallexConfirmationFilename(params: {
  transferId: string;
  payoutId: string;
  date?: Date | string | null;
  firstName?: string | null;
  lastName?: string | null;
}): string {
  const when = params.date ? new Date(params.date) : new Date();
  const datePart = Number.isNaN(when.getTime())
    ? formatConfirmationDate(new Date())
    : formatConfirmationDate(when);
  const recipient = slugRecipientName(params.firstName, params.lastName);
  return `AIRWALLEX_${params.transferId}_${params.payoutId}_${datePart}_${recipient}.pdf`;
}
